export default class PaAttnFlowController {
  static list (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paAttnFlow/list', 'post', params, axiosOption, httpOption);
  }

  static view (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paAttnFlow/view', 'get', params, axiosOption, httpOption);
  }

  static export (sender, params, fileName) {
    return sender.download('/admin/app/paAttnFlow/export', params, fileName);
  }

  static add (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paAttnFlow/add', 'post', params, axiosOption, httpOption);
  }

  static update (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paAttnFlow/update', 'post', params, axiosOption, httpOption);
  }

  static delete (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paAttnFlow/delete', 'post', params, axiosOption, httpOption);
  }

  static startOnlyPaAttnApprovalFlow (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paAttnFlow/startOnly/PaAttnApprovalFlow', 'post', params, axiosOption, httpOption);
  }

  static startWithBusinessKeyPaAttnApprovalFlow (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paAttnFlow/startWithBusinessKey/PaAttnApprovalFlow', 'post', params, axiosOption, httpOption);
  }

  static startAndTakeUserTaskPaAttnApprovalFlow (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paAttnFlow/startAndTakeUserTask/PaAttnApprovalFlow', 'post', params, axiosOption, httpOption);
  }

  static submitUserTaskPaAttnApprovalFlow (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paAttnFlow/submitUserTask/PaAttnApprovalFlow', 'post', params, axiosOption, httpOption);
  }

  static viewTaskBusinessDataPaAttnApprovalFlow (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paAttnFlow/viewTaskBusinessData/PaAttnApprovalFlow', 'get', params, axiosOption, httpOption);
  }

  static viewHistoricTaskBusinessDataPaAttnApprovalFlow (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paAttnFlow/viewHistoricTaskBusinessData/PaAttnApprovalFlow', 'get', params, axiosOption, httpOption);
  }

  static listWorkOrderPaAttnApprovalFlow (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paAttnFlow/listWorkOrder/PaAttnApprovalFlow', 'post', params, axiosOption, httpOption);
  }
}
